export default __webpack_public_path__ + "static/media/staff1.b052aabe.svg";